import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceAll'
})
export class ReplaceAllPipe implements PipeTransform {

  transform(input, placeholderDummies: {
    [key: string]: any;
  } = {}): unknown {
    input = input || '';
    for (const key in placeholderDummies) {
      if (placeholderDummies.hasOwnProperty(key)) {
        const value = placeholderDummies[key];
        if (value) {
          // Wrap the replaced value in strong tags to make it bold
          const boldValue = `<strong>${placeholderDummies[key]}</strong>`;

          // Special handling for duration placeholder to avoid duplicated units like "mins minutes"
          if (/\{\{\s*duration\s*\}\}/i.test(key)) {
            const escaped = this.escapeRegExp(key);
            // Match placeholder optionally followed by whitespace and min/mins/minute/minutes
            // Prefer longest unit match first (minutes -> min) to avoid leaving trailing 'utes'
            const durationPattern = new RegExp(`${escaped}(?:\\s*(?:minutes?|min(?:s)?))?`, 'gi');
            input = input.replace(durationPattern, boldValue);
          } else {
            input = input.replace(new RegExp(this.escapeRegExp(key), 'gi'), boldValue);
          }
        }
      }
    }
    return input;
  }

  private escapeRegExp(text: string): string {
    return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
}
